module.exports = __webpack_public_path__ + "img/1400x100.823bc4d9.png";